var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import ReactGA from 'react-ga';
import reactGtmModule from 'react-gtm-module';
import { Container } from 'typedi';
import { UserManager } from './user';
var GoogleAnalytics = /** @class */ (function () {
    function GoogleAnalytics(params) {
        var gtmId = params.gtmId, trackingCode = params.trackingCode;
        this.trackingCode = trackingCode;
        this.gtmId = gtmId;
    }
    GoogleAnalytics.prototype.initGA = function (channel) {
        if (channel === void 0) { channel = 'default'; }
        ReactGA.initialize(this.trackingCode, { debug: false });
        ReactGA.set({
            campaignId: channel,
        });
    };
    GoogleAnalytics.prototype.initTagManager = function () {
        var tagManagerArgs = {
            gtmId: this.gtmId,
        };
        reactGtmModule.initialize(tagManagerArgs);
    };
    GoogleAnalytics.prototype.trackGAPage = function (page) {
        var user = Container.get(UserManager).getUser();
        var userUuid = user && user.uuid;
        var options = {
            userId: userUuid,
            dimension1: userUuid,
        };
        ReactGA.set(__assign({ page: page }, options));
        ReactGA.pageview(page);
    };
    return GoogleAnalytics;
}());
export { GoogleAnalytics };
//# sourceMappingURL=googleAnalytics.js.map


//////////////////
// WEBPACK FOOTER
// ../core-h5/build/src/services/googleAnalytics.js
// module id = 1227
// module chunks = 0